const React = require('react');
const routerProvider = require('mn-utils/browser/routerProvider');
const withDelay = require('mn-utils/withDelay');
const debounce = require('mn-utils/debounce');

const router = module.exports = routerProvider({
  window,
  Component: React.Component,
  createElement: React.createElement,
  forwardRef: React.forwardRef,
});

if (process.env.MOCK || location.hostname.includes('localhost')) {
  router.Link = router.HashLink;
  router.NavLink = router.HashNavLink;
  router.location$ = router.hashLocation$;
  router.path$ = router.hashPath$;
  router.pushLocation = router.pushHashLocation;
  router.replaceLocation = router.replaceHashLocation;
  router.routerByLocationProvider = router.routerByHashLocationProvider;
}

const {
  replaceLocation,
} = router;

router.pushLocation = withDelay(router.pushLocation, 50);
router.replaceLocation = withDelay(replaceLocation, 50);
router.replaceLocationLazy = withDelay(replaceLocation, 100);
router.backLocationDebounced = debounce(router.backLocation, 250);
